/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pay_Overdue_InvoiceInputs */

const en_pay_overdue_invoice = /** @type {(inputs: Pay_Overdue_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay Overdue Invoice`)
};

const fr_pay_overdue_invoice = /** @type {(inputs: Pay_Overdue_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payer la facture en retard`)
};

const de_pay_overdue_invoice = /** @type {(inputs: Pay_Overdue_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überfällige Rechnung bezahlen`)
};

const it_pay_overdue_invoice = /** @type {(inputs: Pay_Overdue_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagare la fattura in ritardo`)
};

const ru_pay_overdue_invoice = /** @type {(inputs: Pay_Overdue_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оплатить просроченный счет`)
};

const es_pay_overdue_invoice = /** @type {(inputs: Pay_Overdue_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagar factura vencida`)
};

const zh_cn2_pay_overdue_invoice = /** @type {(inputs: Pay_Overdue_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付逾期发票`)
};

const ja_pay_overdue_invoice = /** @type {(inputs: Pay_Overdue_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支払期限を過ぎた請求書の支払い`)
};

const hi_pay_overdue_invoice = /** @type {(inputs: Pay_Overdue_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बकाया बिल का भुगतान करें`)
};

const pt_pt2_pay_overdue_invoice = /** @type {(inputs: Pay_Overdue_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagar fatura vencida`)
};

/**
* | output |
* | --- |
* | "Pay Overdue Invoice" |
*
* @param {Pay_Overdue_InvoiceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pay_overdue_invoice = /** @type {((inputs?: Pay_Overdue_InvoiceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pay_Overdue_InvoiceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_pay_overdue_invoice(inputs)
	if (locale === "de") return de_pay_overdue_invoice(inputs)
	if (locale === "it") return it_pay_overdue_invoice(inputs)
	if (locale === "ru") return ru_pay_overdue_invoice(inputs)
	if (locale === "es") return es_pay_overdue_invoice(inputs)
	if (locale === "zh-CN") return zh_cn2_pay_overdue_invoice(inputs)
	if (locale === "ja") return ja_pay_overdue_invoice(inputs)
	if (locale === "hi") return hi_pay_overdue_invoice(inputs)
	if (locale === "pt-PT") return pt_pt2_pay_overdue_invoice(inputs)
	return en_pay_overdue_invoice(inputs)
});